// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"348":"base","535":"login"}[chunkId] || chunkId) + "." + {"348":"55088403","535":"b1d20ec7","845":"f4774cc9"}[chunkId] + ".js";
};